import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import {onCheck, openPopover, closePopover, reportAnalytics} from './IsIBCInternetCustomerSlice';
import PopOver from '../../../Shared/Popover/Popover';
import RadioInput from '../../../Shared/RadioInput/RadioInput';

import {connect} from 'react-redux';

const isIBCInternetCustomer = (props) => {
  const handleOptionChange = (e) => {
    let currentValue = e.target.value;
    props.onCheck({target: currentValue, currentBox: currentValue});
  };

  const openPopoverHandle = (e) => {
    props.openPopover();
    props.reportAnalytics({
      eventCategory: 'fiber_newsale_process',
      eventAction: 'click_11',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
  };

  return (
    <Container className='ibc-container'>
      <Row>
        <Col className='ibc-background'>
          <Row>
            <Col xs='12' md='12' className='is-ibc'>
              האם אתם כבר לקוחות של חברת unlimited?
              <Image src={require('./images/question-line.svg')}
                onClick={() => openPopoverHandle()}
                alt='סימן שאלה'
                className='img-question'
                id='ibc-help' />
              <PopOver
                className='ibc-popover'
                placement='top'
                text='Unlimited (שידועה גם כ-IBC) היא חברת תקשורת ישראלית המספקת שירותי תשתית סיבים בארץ'
                target='ibc-help'
                isOpen={props.togglePopover}
                closePopover={() => props.closePopover()}
                toggle={props.togglePopover}
              />
            </Col>
          </Row>
          <Row>
            <Col className='ibc-explanation'>מה זה לקוח IBC?</Col>
          </Row>
          <div className='ibc-customer-container'>
            <Row className='ibc-customer'>
              <Col xs='12' md='12'>
                <div>
                  <RadioInput
                    onChange={handleOptionChange}
                    id='radio-ibc'
                    name='groupIsIBC'
                    value='isIBC'
                    checked={props.isIBC === 'isIBC' ? true : false}
                    label={`כן, אנחנו רוצים לעבור ל${window.Config.brand_Name_HE}`}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className='ibc-customer-container'>
            <Row className='ibc-customer'>
              <Col xs='12' md='12'>
                <div>
                  <RadioInput
                    onChange={handleOptionChange}
                    id='radio-not-ibc'
                    name='groupIsIBC'
                    value='isNotIBC'
                    checked={props.isIBC === 'isNotIBC' ? true : false}
                    label='לא, אנחנו לא לקוחות Unlimited '
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    isIBC: state.IsIBCInternetCustomer.isIBC,
    isNotIBC: state.IsIBCInternetCustomer.isNotIBC,
    togglePopover: state.IsIBCInternetCustomer.togglePopover,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {
  onCheck,
  openPopover,
  closePopover,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(isIBCInternetCustomer);
